module.exports = __webpack_public_path__ + "img/bottom_tree_001.3504a482.svg";